import CheckEmail from 'features/auth/resetPassword/screens/CheckEmail/CheckEmail';
import React from 'react';

export default function Page() {
  return <CheckEmail />;
}
